import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import { IStatement } from '../../../model/statement'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchReferences from './fetch-references'
import { IReference, Reference } from '../../../model/reference'
import { stat } from 'fs';

export default async function addStatementReference(context: BareActionContext<StatementState, RootState>, statement: IStatement) {
  if (statement.meta) {
    const newUrl = statement.meta.newUrl
    const newDesc = statement.meta.newDesc
    if (newUrl || newDesc) {
        let reference: IReference = new Reference()
        reference.url = newUrl
        reference.description = newDesc
        statementUtils.statementService.addReference(statement, reference).then((result: any) => {
            statementStore.commitResetStatementReference({ statement: statement })
            fetchReferences(context, statement)
        })
    }
  }

    return
}
